/* eslint-disable prettier/prettier */
<template>
    <div class="grid">
        <div class="grid-title">
            <h4>{{ $t("RATE_PMS") }}</h4>
            <v-btn color="primary" @click="update()" :disabled="isLoading">
                <template>{{ $t("UPDATE") }}</template>
            </v-btn>
        </div>
        <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
        <v-spacer />
        <div class="grid-body py-3 mb-4" v-if="!isLoading">
            <div class="pb-3">
                <div class="d-flex px-3 pb-3 w-100 justify-content-between">
                    <div class="pt-0 d-flex w-100">
                        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
                            {{ $t("_HOTEL_CHAIN.CHAIN_LIST_HOTEL") }}
                        </label>
                        <v-autocomplete item-text="name" item-value="id" :items="hotels" v-model="selecedtHotels" outlined
                            chips dense multiple @change="getPmsRate()">
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1"> <a class="text-primary"
                                        @click="selecedtHotels = hotels.map(e => e.id)">{{
                                            $t('SELECT_ALL') }}</a>
                                    | <a class="text-primary" @click="selecedtHotels = []">{{
                                        $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected"
                                    close @click:close="removeChips(index, selecedtHotels)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.name }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{
                                    selecedtHotels.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div class="d-flex ml-3 w-100">
                        <label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{
                            $t("SALE_PACKAGE") }} </label>
                        <v-autocomplete item-text="text" item-value="value" :items="listPlans" v-model.lazy="planSelect"
                            outlined dense @change="getPmsRate()">
                            <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="config-price">
                    <div class="w-100">
                        <div class="d-sticky h-header-table d-flex px-3">
                            <div class="mr-auto">

                            </div>
                            <div>
                                <div class="small-gutters d-flex">
                                    <div class="text-center font-weight-bold" :style="'width: 94px'" v-for="item in daysOfWeek" :key="item.value">
                                        {{ item.value }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(hotel, indexHotel) in dataPmsRate" class="px-3 pt-3">
                            <div>
                                <div class="mb-1">
                                    <span class="font-weight-bold mb-1">{{ hotel.roomTypeI18ns.find(item => item.lang ===
                                        defaultI18n).name
                                    }} -
                                        {{ hotel.ratePlanI18ns.find(item =>
                                            item.lang === defaultI18n).name }}
                                    </span>
                                <!-- <span>({{ hotels.filter(item =>
                                                                                                                                                                                                                                                                                                                                        selecedtHotels.includes(item.id)).map(e => e.name).join(", ") }})</span> -->
                                    <template v-for="(date, indDate) in hotel.roomRateRangesNew">
                                        <div class="d-flex mb-2">
                                            <div class="pb-0 d-date mr-auto">
                                                <template v-if="
                                                    indexHotel === 0
                                                ">
                                                    <div class="d-flex align-items-center">
                                                        <date-picker :disabled-date="notBeforeToday" @input="changDate(hotel)"
                                                            :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"
                                                            :popup-class="'popup-calendar-desktop-detailhotel'"
                                                            v-model="date.dateSelect" :lang="languageDate"
                                                            :format="'DD/MM/YYYY'" :shortcuts="[]" range
                                                            placeholder="Select date range">
                                                        </date-picker>
                                                        <v-btn color="red" @click="removePeriodSpecialPrice(indDate)"
                                                            class="ml-1" icon small><i class="icon-delete fs-16"></i></v-btn>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} ~
                                                    {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                                                </template>
                                            </div>
                                            <div :key="indDate">
                                                <div class="small-gutters">
                                                    <div class="pb-0 pt-0 d-flex align-items-center">
                                                        <currency-ptd
                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                                                            :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn"
                                                            v-model="date.paxMonday" @input="changePrice(date)" />
                                                    </div>
                                                    <div class="pb-0 pt-0 d-flex align-items-center">
                                                        <currency-ptd
                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " v-model.lazy="date.paxOne" @input="$forceUpdate()" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            "  v-model="date.paxTwo" @input="$forceUpdate()" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'" 
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            "  v-model="date.paxExtra" @input="$forceUpdate()" />
                                                    </div>
                                                    <!-- <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model="date.paxMonday" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model="date.paxMonday" />
                                                    </div>
                                                    <div>
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model="date.paxMonday" />
                                                    </div>
                                                    <div class="mr-0">
                                                        <currency-ptd
                                                            :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                            :options="
                                                                currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                            " :disabled="true" v-model="date.paxMonday" />
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <v-row class="mt-0" v-if="indexHotel === 0">
                                    <v-col class="pt-0 pb-0">
                                        <v-btn color="primary" outlined x-small @click="addDatePriodSpecialPrice()">
                                            <i class="icon-add fs-14"></i>
                                            <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-divider class="mb-0"></v-divider>
                        </div>

                    </div>
                </div>
            </div>
            <div class="text-right px-3">
                <v-btn color="primary" @click="update()" :disabled="isLoading">
                    <template>{{ $t("UPDATE") }}</template>
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { PmsRateService } from "@/_services/ChainManage/pmsRate.service.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    components: {
        "date-picker": () => import('vue2-datepicker'),
        "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
    },
    data() {
        return {
            listRoom: [],
            listPlans: [],
            planSelect: null,

            isLoading: true,
            hotels: [],
            langSystem: this.$i18n.locale,
            selecedtHotels: [],
            listRooms: [],
            selectedRoomType: [],
            daysOfWeek: [
                { code: "PRICE", value: this.$t("PRICE") },
                { code: "PAXONE", value: this.$t("PAXONE") },
                { code: "PAXTOW", value: this.$t("PAXTOW") },
                { code: "PAXEXTRA", value: this.$t("PAXEXTRA") },
                // { code: "THU", value: this.$t("THURSDAY") },
                // { code: "FRI", value: this.$t("FRIDAY") },
                // { code: "SAT", value: this.$t("SATURDAY") },
                // { code: "SUN", value: this.$t("SUNDAY") }
            ],
            currency: "VND",
            dataPmsRate: [],
            objectDate: null
        };
    },
    created() {
        this.initialize();
    },
    methods: {

        async initialize() {
            this.getHotelByChain();
            this.currency = this.priceOptionsVi.suffix;
        },
        async getHotelByChain() {
            await chainService.getHotelByChain(this.defaultI18n).then(res => {
                if (res.responseCode == 0) {
                    this.hotels = res.data;
                    this.selecedtHotels = this.hotels.map(e => e.id);
                }
                this.getAllRoom();
            });
        },
        async getAllRoom() {
            let body = {
                keyword: "",
                status: 1,
                limit: 99999,
                offset: 0,
                orderBy: 'active',
                asc: false,
            };

            chainService.getAllRooms(body).then(res => {
                this.listRooms = res.data.map(e => Object.assign({}, {
                    text: e.i18ns.find(item => item.lang === this.defaultI18n).name,
                    value: e.roomCode
                }
                ));
                this.selectedRoomType = this.listRooms.map(e => e.value);
                this.getAllRate()
            });
        },
        async getAllRate() {
            let body = {
                keyword: "",
                status: 1,
                limit: 99999,
                offset: 0,
                orderBy: 'active',
                asc: false,
            };
            chainService
                .getAllRatePlanChain(body)
                .then(res => {
                    this.listPlans = res.data.map(e => Object.assign({}, {
                        text: e.i18ns.find(item => item.lang === this.defaultI18n).name,
                        value: e.ratePlanCode
                    }
                    ));
                    this.planSelect = this.listPlans[0].value;
                    this.getPmsRate()
                });
        },
        async getPmsRate() {
            this.isLoading = true;
            const body = {
                hotelIds: [...this.selecedtHotels],
                ratePlanCode: this.planSelect
            };
            await PmsRateService.getDetailPmsRate(body).then((res) => {
                if (res.responseCode === 0) {
                    this.dataPmsRate = res.data;
                    let max = -1;
                    this.dataPmsRate.forEach(element => {
                        if (element.roomRateRanges.length > max) {
                            max = element.roomRateRanges.length;
                            this.objectDate = JSON.parse(JSON.stringify(element.roomRateRanges));
                        }
                    })

                    this.dataPmsRate.forEach(element => {
                        element.roomRateRangesNew = JSON.parse(JSON.stringify(this.objectDate));
                    });
                    this.dataPmsRate.forEach(element => {
                        for (let index = 0; index < element.roomRateRangesNew.length; index++) {
                            if (element.roomRateRanges.filter(e => e.startDate === element.roomRateRangesNew[index].startDate && e.endDate === element.roomRateRangesNew[index].endDate).length === 0) {
                                element.roomRateRangesNew[index].paxFriday = null;
                                element.roomRateRangesNew[index].paxMonday = null;
                                element.roomRateRangesNew[index].paxSaturday = null;
                                element.roomRateRangesNew[index].paxSunday = null;
                                element.roomRateRangesNew[index].paxThursday = null;
                                element.roomRateRangesNew[index].paxTuesday = null;
                                element.roomRateRangesNew[index].paxWednesday = null;
                                element.roomRateRangesNew[index].paxOne = null;
                                element.roomRateRangesNew[index].paxTwo = null;
                                element.roomRateRangesNew[index].paxExtra = null;
                            } else {
                                element.roomRateRangesNew[index] = JSON.parse(JSON.stringify(element.roomRateRanges.find(e => e.startDate === element.roomRateRangesNew[index].startDate && e.endDate === element.roomRateRangesNew[index].endDate)))

                            }
                        }
                    });
                    this.dataPmsRate.forEach(element => {
                        element.roomRateRangesNew.forEach(date => {
                            date.dateSelect = [
                                new Date(moment(date.startDate).format("YYYY-MM-DD")),
                                new Date(
                                    moment(date.endDate)
                                        .format("YYYY-MM-DD")
                                )
                            ]
                        })
                    });

                } else {
                    _alert(res, this.$t(res.data), false);
                }
                this.isLoading = false
            });
        },
        async update() {
            let arrDate = [];
            let check = false;
            const dates = [];
            this.dataPmsRate[0].roomRateRangesNew.forEach(
                date => {
                    arrDate.push(date.dateSelect);
                }
            );
            arrDate.forEach((date) => {
                if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
                    _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
                    check = true;
                    return true;
                }
                let fromDate = moment(date[0], "YYYY-MM-DD");
                let toDate = moment(date[1], "YYYY-MM-DD");
                while (fromDate <= toDate) {
                    dates.push(fromDate.format("YYYY-MM-DD"));
                    fromDate = moment(fromDate).add(1, "day");
                }
            });
            if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
                _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
                return;
            }
            const body = {
                hotelIds: [...this.selecedtHotels],
                ratePlanCode: this.planSelect,
                roomRates: JSON.parse(JSON.stringify(this.dataPmsRate))
            }
            body.roomRates.forEach(element => {
                element.roomRateRanges = JSON.parse(JSON.stringify(element.roomRateRangesNew));
                delete element.roomRateRangesNew
                element.roomRateRanges.forEach(e => {
                    delete e.dateSelect
                })
            });
            await PmsRateService.UpdatePmsRate(body).then((res) => {
                if (res.responseCode === 0) {
                    this.getPmsRate();
                    _alert(res, this.$t(res.data), false);
                } else {
                    _alert(res, this.$t(res.data), false);
                }
            })
        },
        addDatePriodSpecialPrice() {

            if (this.dataPmsRate[0].roomRateRangesNew.length === 0) {
                let from = moment(new Date())
                    .format("YYYY-MM-DD");
                let to = moment(new Date())
                    .add(1, "day")
                    .format("YYYY-MM-DD");
                this.dataPmsRate.forEach(rr => {
                    rr.roomRateRangesNew.push({
                        dateSelect: [new Date(from), new Date(to)],
                        paxFriday: null,
                        paxMonday: null,
                        paxSaturday: null,
                        paxSunday: null,
                        paxThursday: null,
                        paxTuesday: null,
                        paxWednesday: null,
                        paxOne: null,
                        paxTwo: null,
                        paxExtra: null,
                        startDate: from,
                        endDate: to
                    });
                });
                this.$forceUpdate()

            } else {
                let prevPeriod = this.dataPmsRate[0].roomRateRangesNew[
                    this.dataPmsRate[0].roomRateRangesNew
                        .length - 1
                ];
                const tomorrow = new Date();
                tomorrow.setDate(new Date().getDate() + 365 * 2);

                if (
                    new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
                    tomorrow
                ) {
                    return;
                }
                let from = moment(prevPeriod.dateSelect[1])
                    .add(1, "day")
                    .format("YYYY-MM-DD");
                let to = moment(prevPeriod.dateSelect[1])
                    .add(2, "day")
                    .format("YYYY-MM-DD");
                this.dataPmsRate.forEach(rr => {
                    rr.roomRateRangesNew.push({
                        dateSelect: [new Date(from), new Date(to)],
                        paxFriday: null,
                        paxMonday: null,
                        paxSaturday: null,
                        paxSunday: null,
                        paxThursday: null,
                        paxTuesday: null,
                        paxWednesday: null,
                        paxOne: null,
                        paxTwo: null,
                        paxExtra: null,
                        startDate: from,
                        endDate: to
                    });
                });
                this.$forceUpdate()

            }



        },
        changDate(date) {
            let arrDate = [];
            date.roomRateRangesNew.forEach(e => {
                arrDate.push(e.dateSelect);
            });
            this.dataPmsRate.forEach(rr => {
                rr.roomRateRangesNew.forEach((date, index) => {
                    date.endDate = moment(arrDate[index][1]).format("YYYY-MM-DD");
                    date.startDate = moment(arrDate[index][0]).format("YYYY-MM-DD");
                    date.dateSelect = arrDate[index];
                });
            });
            this.$forceUpdate()
        },
        async removePeriodSpecialPrice(ind) {
            this.dataPmsRate.forEach(date => {
                date.roomRateRangesNew.splice(ind, 1);
            });
            this.$forceUpdate()
        },
        changePrice(date) {
            date.paxFriday = date.paxMonday;
            date.paxMonday = date.paxMonday;
            date.paxSaturday = date.paxMonday;
            date.paxSunday = date.paxMonday;
            date.paxThursday = date.paxMonday;
            date.paxTuesday = date.paxMonday;
            date.paxWednesday = date.paxMonday;
            date.paxOne = date.paxMonday;
            date.paxTwo = date.paxMonday;
            date.paxExtra = date.paxMonday;
            this.$forceUpdate()
        },
        _moment: moment
    }
};
</script>
